var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-7",
    transform: "translate(-664.000000, -1414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropbox",
    transform: "translate(664.000000, 1414.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "testimonial",
    d: "M39.5,44.1l14.7-9.4l-14.7-9.4L54.3,16L69,25.4l-14.7,9.4L69,44.1l-14.7,9.4L39.5,44.1z M24.7,56.6l14.8-9.4 l14.7,9.4L39.5,66L24.7,56.6z M39.5,25.4l-14.7,9.4l14.7,9.4l-14.7,9.4L10,44.1l14.8-9.4L10,25.4L24.8,16L39.5,25.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.48390de556ccea81a6d220cc8aa17a0d.svg";
export { ForwardRef as ReactComponent };